// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.CustomerTagDto
export class CustomerTagDto extends EntityBaseDto {
    public name: string = null;
}


    



